export default __webpack_public_path__ + "static/media/16_2.51393af8.jpg";